import React, { useState, useEffect } from "react"
import Block from "@bappweb/block"
import Panel from "@bappweb/panel"
import List from "@bappweb/list"
import Page from "@smpu-web/globalmodules/page"
import "../assets/style.scss"
import { getCidParameter, getConfigValue, isNullOrEmpty } from "@smpu-web/utils/utils"
import { useAppSelector } from "../../../config/hook"

const Notes = () => {
    const sessionData = useAppSelector((state) => state.sessionData.response)

    const [campaignText, setCampaignText] = useState('')
    const [campaignDetailText, setCampaignDetailText] = useState('')

    let cidParameter = getCidParameter();
    useEffect(() => {
        if (sessionData?.configList) {
            if (cidParameter != null) {
                if (!isNullOrEmpty(getConfigValue(sessionData?.configList, `PosLead.CampaignText.Landing.Bottom.${cidParameter}`))) {
                    setCampaignText(getConfigValue(sessionData?.configList, `PosLead.CampaignText.Landing.Bottom.${cidParameter}`))
                }
                else {
                    if (!isNullOrEmpty(getConfigValue(sessionData?.configList, "PosLead.CampaignText.Landing.Bottom"))) {
                        setCampaignText(getConfigValue(sessionData?.configList, "PosLead.CampaignText.Landing.Bottom"))
                    }
                }
                if (!isNullOrEmpty(getConfigValue(sessionData?.configList, `PosLead.CampaignText.Landing.Bottom2.${cidParameter}`))) {
                    setCampaignDetailText(getConfigValue(sessionData?.configList, `PosLead.CampaignText.Landing.Bottom2.${cidParameter}`))
                }
                else {
                    if (!isNullOrEmpty(getConfigValue(sessionData?.configList, "PosLead.CampaignText.Landing.Bottom2"))) {
                        setCampaignDetailText(getConfigValue(sessionData?.configList, "PosLead.CampaignText.Landing.Bottom2"))
                    }
                }
            }
            else {
                setCampaignText(getConfigValue(sessionData?.configList, "PosLead.CampaignText.Landing.Bottom"))
                setCampaignDetailText(getConfigValue(sessionData?.configList, "PosLead.CampaignText.Landing.Bottom2"))
            }
        }

    }, [sessionData])

    return (
        <Page padding={false}>
            <Panel hasFooter={false} noHeader className="notes-container accordion-container">
                <Block dangerouslySetInnerHTML={{ __html: campaignText }} />
                <List
                    accordion
                    accordionCollapsible
                    activeItem={0}
                    custom={false}
                    disabled={false}
                    expandOnlyOne
                    withPadding
                    withoutBorder={false}
                    className="campaign-list-title"
                >
                    <List.Item
                        accordion={false}
                        accordionCollapsible
                        disabled={false}
                        preventDefault
                        title="Kampanya Detayları"
                        withPadding={true}
                        className="campaign-list-item"
                    >
                        <Block dangerouslySetInnerHTML={{ __html: campaignDetailText }} />
                    </List.Item>
                </List>
            </Panel>
        </Page>
    )
}

export default Notes
